export default __webpack_public_path__ + "static/2189-3a624889b61b13e5c240059c0ee688fd.gif";